/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../../consts';
import { RouteWithComponent } from '../../interfaces';

const AdministratorDashboardView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/administratorDashboard/administratorDashboard.view')
);
const AdminOfwcaDashboardView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/adminOfwcaDashboard/adminOfwcaDashboard.view')
);
const ComplaintAddView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/complaintAdd/complaintAdd.view')
);
const ComplaintDetailsView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/complaintDetails/complaintDetails.view')
);
const ComplaintsListView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/complaintsList/complaintsList.view')
);
const ContractDetailsView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/contractDetails/contractDetails.view')
);
const SheetDetailsWithProviderView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/sheetDetails/sheetDetailsWithProvider.view')
);
const SheetsAndComplaintsListView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/sheetsAndComplaintsList/sheetsAndComplaintsList.view')
);
const UserDashboardView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/userDashboard/userDashboard.view')
);
const UserMonthSheetView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/userMonthSheet/userMonthSheet.view')
);
const UserSheetsView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/userSheets/userSheets.view')
);
const UserWithoutDocumentsPage: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/userWithoutDocumentsPage/userWithoutDocumentsPage.component')
);
const IntroView: LazyExoticComponent<React.FC> = lazy(
  (): Promise<{ default: FC }> => import('./views/intro/intro.view')
);

export const provisionsRoutes: RouteWithComponent[] = [
  { pathSettings: routingConfig.provisions.children.provisionsIntro, component: IntroView },
  { pathSettings: routingConfig.provisions.children.provisionsAdministratorDashboard, component: AdministratorDashboardView },
  { pathSettings: routingConfig.provisions.children.provisionsAdminOfwcaDashboard, component: AdminOfwcaDashboardView },
  { pathSettings: routingConfig.provisions.children.provisionsAddComplaint, component: ComplaintAddView },
  { pathSettings: routingConfig.provisions.children.provisionsComplaintDetails, component: ComplaintDetailsView },
  { pathSettings: routingConfig.provisions.children.provisionsComplaintsList, component: ComplaintsListView },
  { pathSettings: routingConfig.provisions.children.provisionsContract, component: ContractDetailsView },
  { pathSettings: routingConfig.provisions.children.provisionsSheet, component: SheetDetailsWithProviderView },
  { pathSettings: routingConfig.provisions.children.provisionsSheets, component: SheetsAndComplaintsListView },
  { pathSettings: routingConfig.provisions.children.provisionsUserDashboard, component: UserDashboardView },
  { pathSettings: routingConfig.provisions.children.provisionsUserMonthSheet, component: UserMonthSheetView },
  { pathSettings: routingConfig.provisions.children.provisionsUserMonthSheets, component: UserSheetsView },
  { pathSettings: routingConfig.provisions.children.provisionsUserWithoutDocuments, component: UserWithoutDocumentsPage },
];
